import React from "react";

const ABOUT_IMG = "/about-anna.jpg";

export default function About({ t }) {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#F8F9FA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative w-full h-[420px] sm:h-[520px] overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Female craftsman portrait"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2">
          <div
            className="text-[12px] tracking-[0.28em] uppercase text-[#475569] mb-4"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            — {t.about.eyebrow}
          </div>
          <h2
            className="text-[34px] sm:text-[42px] leading-[1.08] tracking-tight text-[#0A0F1C] font-medium"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            {t.about.title}
          </h2>
          <div className="mt-8 space-y-5">
            <p
              className="text-[16px] leading-relaxed text-[#475569]"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              {t.about.p1}
            </p>
            <p
              className="text-[16px] leading-relaxed text-[#475569]"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              {t.about.p2}
            </p>
          </div>
          <div
            className="mt-10 text-[22px] italic text-[#0F2C29]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {t.about.signature}
          </div>
        </div>
      </div>
    </section>
  );
}
